import { DATE_ISO_FORMAT } from '../../../constants/datetime';
import { eventMomentFactory } from '../../../misc/eventMomentFactory';

export function createDateFilter(event, date, { propName = 'start_local', format = DATE_ISO_FORMAT, filterDateFormat = DATE_ISO_FORMAT } = {}) {
    const parsedDate = eventMomentFactory(event, date, filterDateFormat);
    return (item) => {
        let value = item?.[propName];
        if (!value) return false;

        return eventMomentFactory(event, value, format).isSame(parsedDate, 'day');
    };
}
